import { IOffer } from '../../../repositories/dailyrent/entities/offer/Offer';

// Просмотренность оффера мультипина: серверный флаг ИЛИ отметка в redux (без localStorage)
export function withViewedCianIdsState(offer: IOffer, viewedCianIds: Record<number, true>): IOffer {
  return { ...offer, isViewed: offer.isViewed || Boolean(viewedCianIds[offer.cianId]) };
}
